import { Box, Text, useModal, getAccountEllipsis } from 'vvs-uikit'
import { useWeb3React } from '@web3-react/core'
import { useTranslation } from 'contexts/Localization'
import { useConnectionError } from 'state/user/hooks'
import useAuth from 'hooks/useAuth'
import useENSName from 'hooks/ENS/useENSName'

import useVvsGotchiWalletModal from './useWalletModal'
import WalletModal from './WalletModal'
import SwitchNetworkModal from '../UserMenu/SwitchNetworkModal'
import { FlexItem, SwtichNetworkBtn } from './styles'

const VvsGotchiWalletItem = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { ENSName } = useENSName(account)

  const [connectionError] = useConnectionError()
  const { logout } = useAuth()

  const { onPresentConnectModal } = useVvsGotchiWalletModal()
  const [onSwitchNetworkModal] = useModal(<SwitchNetworkModal ActionButton={SwtichNetworkBtn} />)
  const [openWalletModal] = useModal(
    <WalletModal account={account} onAction={logout} />,
    true,
    false,
    'vvsgotchiWallet',
  )

  const accountEllipsis = getAccountEllipsis(account, 4)

  return (
    <FlexItem
      py="1.5em"
      my="1em"
      alignItems="center"
      onClick={connectionError ? onSwitchNetworkModal : account ? openWalletModal : onPresentConnectModal}
    >
      <Box mr="1em">
        <img
          src={
            connectionError
              ? '/images/vvsGotchi/network_error.png'
              : account
              ? '/images/vvsGotchi/wallet.png'
              : '/images/vvsGotchi/empty_wallet.png'
          }
          alt="vvs gotchi wallet icon"
          width="24px"
          height="24px"
        />
      </Box>
      <Text color={connectionError ? 'failure' : 'white'} fontSize="20px" fontWeight="600">
        {connectionError ? t('Wrong Network') : account ? ENSName || accountEllipsis : t('Connect Wallet')}
      </Text>
    </FlexItem>
  )
}

export default VvsGotchiWalletItem
